import { useQuery } from "@apollo/client";
import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { GET_SCHEDULE_BY_MONTH } from "../../../quries/schedule";
import ScheduleInput from "./ScheduleInput";

interface ScheduleComponentProps {
  firstDate: any;
  secondDate: any;
  month: any;
  setMonth: any;
}

const useStyles = makeStyles((theme) => ({}));

function ScheduleComponent({
  firstDate,
  secondDate,
  month,
  setMonth,
}: ScheduleComponentProps) {
  const classes = useStyles();
  const [schedule, setSchedule] = useState<any>(null);
  const [nowMonth, setNowMonth] = useState<any>(null);

  const { data, error, loading } = useQuery(GET_SCHEDULE_BY_MONTH, {
    fetchPolicy: "no-cache",

    variables: {
      where: {
        schedule_date_gt: firstDate,
        schedule_date_lt: secondDate,
      },
      sort: "schedule_date:DESC",
    },
  });

  useEffect(() => {
    if (data) {
      setSchedule(data.schedules);
    }
    return () => {
      setSchedule(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.schedules) {
    console.log(error);
  }

  if (schedule) {
    console.log(schedule);
    return (
      <Grid xs={12} item style={{ paddingTop: 16 }}>
        <Grid
          xs={12}
          item
          container
          style={{
            fontSize: 40,
            fontWeight: 800,
            fontFamily: "'Noto Sans KR'",
          }}
        >
          {/* <Grid xs={4}>
            <Moment locale="ko" format="YYYY년 MMM">
              {month}
            </Moment>
          </Grid> */}
          {/* <Grid xs={4}></Grid> */}
          <Grid xs={4} item>
            <ScheduleInput setMonth={setMonth} month={month} />
          </Grid>
          <Grid
            xs={8}
            item
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
              marginBottom: 8,
              textAlign: "right",
              paddingTop: 16,
            }}
          >
            노동인권문화제 일정
          </Grid>
        </Grid>
        <Grid xs={12} item style={{}}>
          {schedule.map((element: any, index: any) => {
            return (
              <Grid
                xs={12}
                item
                container
                key={`schedule-${element.schedule_text}-${index}`}
                style={{ paddingBottom: 4 }}
              >
                {/* <Grid xs={4}></Grid> */}
                <Grid
                  xs={4}
                  item
                  style={{
                    textAlign: "right",
                    fontWeight: 700,
                    fontSize: 32,

                    fontFamily: "'Noto Sans KR'",
                  }}
                >
                  {/* <Moment locale="ko" format="YYYY년 MMM Do"> */}
                  <Grid item></Grid>
                  <Grid item style={{ textAlign: "right" }}>
                    <Moment locale="ko" format="D일">
                      {element.schedule_date}
                    </Moment>
                  </Grid>

                  <Grid item></Grid>
                </Grid>
                <Grid
                  xs={8}
                  item
                  style={{
                    fontWeight: 300,
                    fontSize: 32,
                    fontFamily: "'Noto Sans KR'",
                    textAlign: "right",
                  }}
                >
                  {element.schedule_text}
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  } else {
    return <div></div>;
  }
}

export default ScheduleComponent;
